import { useQuery, gql } from '@apollo/client';
import { useParams } from 'react-router-dom';

const MARKETPLACE_BREADCRUMB_QUERY = gql`
  query MarketplaceBreadcrumb($venueSlug: String!, $spaceSlug: String) {
    marketplaceBreadcrumb(venueSlug: $venueSlug, spaceSlug: $spaceSlug) {
      spaceSlug
      spaceName
      venueSlug
      venueName
      venueCity
      venueState
      organizationSlug
      organizationName
    }
  }
`;

export const useMarketplaceBreadcrumbs = () => {
  const { spaceSlug, venueSlug } = useParams();

  const { data: breadcrumbData, loading } = useQuery(
    MARKETPLACE_BREADCRUMB_QUERY,
    {
      variables: {
        venueSlug,
        spaceSlug,
      },
      skip: !venueSlug,
    },
  );

  return {
    marketplaceBreadcrumb: breadcrumbData?.marketplaceBreadcrumb ?? null,
    loading,
  };
};
